<template>
  <generic-in-app-screen>
    <b-container class="flex-grow-1 d-flex flex-column">
      <h1 class="my-5">
        <b>{{ $t('project_hash') }}</b>
      </h1>

      &nbsp;
      {{ project_hash_string }}
      <b-button
        variant="outline-secondary"
        class="btn mt-3"
        @click="download_hash"
      >
        {{ $t('download_hash') }}
      </b-button>
    </b-container>
  </generic-in-app-screen>
</template>

<style scoped>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
</style>

<i18n>
{
  "en": {
    "project_hash": "Making a project save",
    "download_hash": "Download project save file"
  },
  "fr": {
    "project_hash": "Effectuer une sauvegarde du projet",
    "download_hash": "Télécharger la sauvegarde du projet"
  }
}
</i18n>

<script>
import { subscription_mixin, project_mixin } from '@/components/mixin.js'
import { save_project_snapshot } from '@/api/subscriptions.js'
import GenericInAppScreen from '@/components/generic_in_app_screen.vue'

export default {
  name: 'ProjectHash',
  components: {
    GenericInAppScreen,
  },
  mixins: [subscription_mixin, project_mixin],
  data() {
    return {
      project_hash_string: '',
    }
  },
  computed: {
    // project_id() {
    //   let route = this.$route.path
    //   let regexp = new RegExp('(\\d)*/project_hash')
    //   let regexp_match = route.match(regexp)[0].split('/')
    //   let res = Number(regexp_match[0])
    //   return res
    // },
  },
  beforeMount() {
    this.fetch_collections(['projects', 'users', 'project_rights'])
  },
  methods: {
    async download_hash() {
      let hash_string = await save_project_snapshot(this.project_id)
      this.project_hash_string = hash_string
    },
  },
}
</script>
